import React, {FC} from "react";
import {ArrowBackIos} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Button} from "@mui/material";
import {useNavigate} from "react-router-dom";

interface IBackButton {
    fallbackUrl?: string;
}

export const BackButton: FC<IBackButton> = ({fallbackUrl}) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        if (window.history.length > 1) {
            navigate(-1);
        }
        else {
            navigate(fallbackUrl ?? "/");
        }
    };

    return (
        <Button
            startIcon={<ArrowBackIos/>}
            onClick={handleBackClick}
            variant="contained"
            color="primary"
            sx={{
                marginRight: 2,
                backgroundColor: theme => theme.palette.button.primary,
                color: theme => theme.palette.button.text,
                "&:hover": {
                    backgroundColor: theme => theme.palette.button.hover,
                },
            }}
        >
            <Locale localeId={IdlocaGeneric.back}/>
        </Button>
    );
};
